import React, { useEffect, useRef, useState } from 'react';
import { createChart, CandlestickSeries } from 'lightweight-charts';
import AskLiveChart from '../../components/ai/AskLiveChart';

const ReimaginedChartInsights = () => {
  const [symbol, setSymbol] = useState('BTCUSD');
  const [chartData, setChartData] = useState([]);
  const [showAskChartModal, setShowAskChartModal] = useState(false);
  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);
  const chartContextPrompt = `Show key technical insight for ${symbol} 1D setup.`;

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetch(
          `https://us-central1-tradingfunda-4376a.cloudfunctions.net/api/getHistoricalData?symbol=${symbol}`
        );
        const data = await response.json();
        if (Array.isArray(data)) {
          setChartData(data);
        } else {
          console.error('Data is not an array:', data);
        }
      } catch (error) {
        console.error('Error fetching historical data:', error);
      }
    };

    loadData();
  }, [symbol]);

  useEffect(() => {
    if (!chartData.length) return;

    if (chartRef.current) {
      chartRef.current.remove();
      chartRef.current = null;
    }

    const chart = createChart(chartContainerRef.current, {
      width: chartContainerRef.current.clientWidth,
      height: 450,
      layout: {
        background: { color: '#121212' },
        textColor: '#ffffff',
      },
      grid: {
        vertLines: { color: '#2f2f2f' },
        horzLines: { color: '#2f2f2f' },
      },
      timeScale: {
        borderColor: '#3f3f3f',
        timeVisible: true,
      },
    });

    const candleSeries = chart.addSeries(CandlestickSeries, {
      upColor: '#2ECC71',
      downColor: '#E74C3C',
      borderVisible: false,
      wickUpColor: '#2ECC71',
      wickDownColor: '#E74C3C',
    });

    candleSeries.setData(chartData);
    chart.timeScale().fitContent();
    chartRef.current = chart;
  }, [chartData]);

  return (
    <div style={{ backgroundColor: '#232830', minHeight: '100vh', color: '#fff', padding: '40px' }}>
      <h1 style={{ color: '#FF7C24', textAlign: 'center', marginBottom: '30px' }}>
        📈🐂 FinTorro SmartChart
      </h1>

      {/* Input + Ask AI */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '30px', flexWrap: 'wrap', gap: '12px' }}>
        <input
          value={symbol}
          onChange={(e) => setSymbol(e.target.value)}
          placeholder="Type symbol e.g. BTCUSD"
          style={{
            padding: '12px',
            fontSize: '18px',
            borderRadius: '12px',
            width: '280px',
            border: '1px solid #CED4DA',
            color: '#232830',
          }}
        />
        <button
          onClick={() => {
            setShowAskChartModal(true);
          }}
          style={{
            backgroundColor: '#FF7C24',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: '12px',
            border: 'none',
            fontSize: '16px',
            fontWeight: 'bold',
            transition: 'transform 0.1s ease-in-out',
          }}
          onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
          onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          🔍 Ask the Chart
        </button>
      </div>

      {/* Chart Container */}
      <div
        ref={chartContainerRef}
        style={{
          position: 'relative',
          margin: '0 auto',
          maxWidth: '960px',
          height: '450px',
          borderRadius: '12px',
          overflow: 'hidden',
        }}
      />

      {/* Footer Note */}
      <div style={{ textAlign: 'center', marginTop: '30px', fontSize: '16px' }}>
        <span style={{ color: '#FF7C24', fontWeight: 'bold' }}>Hint:</span>{' '}
        <span>Type a market symbol like BTCUSD, AAPL, or EURUSD to explore charts.</span>
      </div>

      {/* Ask Chart Modal */}
      <AskLiveChart
        show={showAskChartModal}
        onClose={() => setShowAskChartModal(false)}
        instrument={symbol.replace('-', '')}
        charttype="live"
        timeframe="1D"
        chartContextPrompt={chartContextPrompt}
      />
    </div>
  );
};

export default ReimaginedChartInsights;



// import React, { useEffect, useRef, useState } from 'react';
// import { createChart, CandlestickSeries } from 'lightweight-charts';
// import AskLiveChart from '../../components/ai/AskLiveChart';

// const ReimaginedChartInsights = () => {
//   const [symbol, setSymbol] = useState('BTCUSD');
//   const [chartData, setChartData] = useState([]);
//   const [showAskChartModal, setShowAskChartModal] = useState(false);
//   const chartContainerRef = useRef(null);
//   const chartRef = useRef(null);
//   const chartContextPrompt = `Show key technical insight for ${symbol} 1D setup.`;

//   // ✅ Fetch historical OHLC data
//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         const response = await fetch(`https://us-central1-tradingfunda-4376a.cloudfunctions.net/api/getHistoricalData?symbol=${symbol}`);
//         const data = await response.json();
//         if (Array.isArray(data)) {
//           setChartData(data);
//         } else {
//           console.error('Data is not an array:', data);
//         }
//       } catch (error) {
//         console.error('Error fetching historical data:', error);
//       }
//     };

//     loadData();
//   }, [symbol]);

//   // ✅ Render chart when data is ready
//   useEffect(() => {
//     if (!chartData.length) return;

//     // Remove existing chart if any
//     if (chartRef.current) {
//       chartRef.current.remove();
//       chartRef.current = null;
//     }

//     const chart = createChart(chartContainerRef.current, {
//       width: chartContainerRef.current.clientWidth,
//       height: 450,
//       layout: {
//         background: { color: '#121212' },
//         textColor: '#ffffff',
//       },
//       grid: {
//         vertLines: { color: '#2f2f2f' },
//         horzLines: { color: '#2f2f2f' },
//       },
//       timeScale: {
//         borderColor: '#3f3f3f',
//         timeVisible: true,
//       },
//     });

//     const candleSeries = chart.addSeries(CandlestickSeries, {
//       upColor: '#2ECC71',
//       downColor: '#E74C3C',
//       borderVisible: false,
//       wickUpColor: '#2ECC71',
//       wickDownColor: '#E74C3C',
//     });

//     candleSeries.setData(chartData);
//     chart.timeScale().fitContent(); // ✅ Fit chart to view
//     chartRef.current = chart;

//     // ✅ Smart Overlay Blocks (optional visual hint zones)
//     drawOverlay('No Trade Zone', 100, 60, 'rgba(255,0,0,0.25)');
//     drawOverlay('Fakeout Detected', 300, 180, 'rgba(255,255,0,0.25)');

//     function drawOverlay(label, left, top, bgColor) {
//       const node = document.createElement('div');
//       node.innerText = label;
//       Object.assign(node.style, {
//         position: 'absolute',
//         left: `${left}px`,
//         top: `${top}px`,
//         backgroundColor: bgColor,
//         color: '#fff',
//         padding: '6px 12px',
//         borderRadius: '6px',
//         fontSize: '13px',
//         zIndex: 10,
//         pointerEvents: 'none',
//       });
//       chartContainerRef.current.appendChild(node);
//     }

//     return () => {
//       if (chartRef.current) {
//         chartRef.current.remove();
//         chartRef.current = null;
//       }
//     };
//   }, [chartData]);

//   return (
//     <div style={{ backgroundColor: '#232830', minHeight: '100vh', color: '#fff', padding: '40px' }}>
//       <h1 style={{ color: '#FF7C24', textAlign: 'center' }}>📊 FinTorro SmartChart</h1>

//       {/* Input + Ask AI */}
//       <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
//         <input
//           value={symbol}
//           onChange={(e) => setSymbol(e.target.value)}
//           placeholder="Type symbol e.g. BTCUSD"
//           style={{
//             padding: '12px',
//             fontSize: '18px',
//             borderRadius: '6px',
//             width: '300px',
//             marginRight: '12px',
//             border: '1px solid #ccc',
//           }}
//         />
//         <button
//           onClick={() => setShowAskChartModal(true)}
//           style={{
//             backgroundColor: '#007bff',
//             color: '#fff',
//             padding: '12px 20px',
//             borderRadius: '6px',
//             border: 'none',
//             fontSize: '16px',
//           }}
//         >
//           Ask the Chart
//         </button>
//       </div>

//       {/* Chart Container */}
//       <div
//         ref={chartContainerRef}
//         style={{
//           position: 'relative',
//           margin: '0 auto',
//           maxWidth: '960px',
//           height: '450px',
//         }}
//       />

//       {/* Footer Note */}
//       <div style={{ textAlign: 'center', marginTop: '20px' }}>
//         <span style={{ color: '#FF7C24', fontWeight: 'bold' }}>Note:</span>{' '}
//         <span>Type ticker symbol to view a new chart.</span>
//       </div>

//       {/* Ask Modal */}
//       <AskLiveChart
//         show={showAskChartModal}
//         onClose={() => setShowAskChartModal(false)}
//         instrument={symbol.replace('-', '')}
//         charttype="live"
//         timeframe="1D"
//         chartContextPrompt={chartContextPrompt}
//       />
//     </div>
//   );
// };

// export default ReimaginedChartInsights;
